import React, { Component, Fragment, MouseEvent } from 'react';
import { Trans } from 'react-i18next';
import { compose } from 'recompose';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

import { SocialAccount } from 'api';
import { withUser, IWithUser } from 'providers';
import { getSocialAccountName } from 'helpers';

interface IProps {
  accounts: SocialAccount[];
  selectedAccount: SocialAccount;
  onConnect: () => void;
  onChange: (account: SocialAccount) => void;
}

interface IPropsEnhanced extends IProps, IWithUser, WithStyles<typeof styles> {}

interface IState {
  anchorEl: HTMLElement;
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      paddingLeft: 0,
      fontSize: 16,
      lineHeight: '20px',
      transition: 'color 150ms ease-in-out',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(withUser, withStyles(styles));

class Accounts extends Component<IPropsEnhanced, IState> {
  state: IState = {
    anchorEl: null,
  };

  handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleChange = (connection: SocialAccount) => () => {
    this.handleClose();
    this.props.onChange(connection);
  };

  handleConnect = () => {
    this.handleClose();
    this.props.onConnect();
  };

  renderAccount = (account: SocialAccount) => {
    const { selectedAccount } = this.props;
    const isSelected = account.id === selectedAccount.id;

    return (
      <MenuItem selected={isSelected} key={account.id} onClick={this.handleChange(account)}>
        {getSocialAccountName(account)}
      </MenuItem>
    );
  };

  render() {
    const { classes, accounts, selectedAccount } = this.props;
    const { anchorEl } = this.state;
    const name = getSocialAccountName(selectedAccount);

    return (
      <Fragment>
        <Button onClick={this.handleClick} className={classes.button} endIcon={<ArrowDropDown />}>
          {name}
        </Button>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose}>
          {accounts.map(this.renderAccount)}
          <MenuItem onClick={this.handleConnect}>
            <Trans i18nKey="sharing:connectAnother" />
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }
}

export default enhancers(Accounts);
